<template>
  <div class="box-agendar" @click="openWhatsApp">
    <div class="calendario-icon">
      <i class="fa-brands fa-whatsapp custom-size"></i>
    </div>

    <a :href="whatsappLink" target="_blank" class="whats-icon" @click.stop>
      <i class="fa-brands fa-whatsapp custom-size-whats"></i>
      <span class="whatsapp-text">{{ text }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: "FloatingWhatsapp",

  props: {
    phone: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "Entre em contato",
    },
  },

  computed: {
    whatsappLink() {
      return `https://wa.me/${this.phone}`;
    },
  },

  methods: {
    openWhatsApp() {
      window.open(this.whatsappLink, "_blank");
    },
  },
};
</script>

<style scoped>
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css");
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

.box-agendar {
  font-family: "Montserrat", serif;
  position: fixed;
  top: 60%;
  right: 0;
  transform: translateY(-50%);
  background-color: #e0effe;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  border-radius: 8px 0 0 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: width 0.3s ease-in-out;
  overflow: hidden;
  cursor: pointer;
  padding: 20px 10px;
  z-index: 2147483647;
}

.box-agendar:hover {
  width: 250px;
  justify-content: center;
  padding: 20px 10px;
}

.custom-size {
  transition: opacity 0.3s ease, transform 0.3s ease;
  color: #937a55;
  font-size: 28px;
  margin-left: 6px;
}

.box-agendar:hover .calendario-icon {
  opacity: 0;
  transform: scale(0.8);
}

.whats-icon {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #345e89;
  opacity: 0;
  text-decoration: none;
}

.box-agendar:hover .whats-icon {
  opacity: 1;
  transform: scale(1.1);
  margin-left: -46px;
}

.custom-size-whats {
  transition: opacity 0.3s ease, transform 0.3s ease;
  color: #345e89;
  font-size: 28px;
  margin-right: 12px;
}

.whatsapp-text {
  color: #345e89;
  font-size: 14px;
  opacity: 0;
  transform: scale(0.8);
  transition: opacity 0.5s ease-in 0.2s, transform 0.1s ease-in 0.1s;
}

.box-agendar:hover .whatsapp-text {
  opacity: 1;
  transform: scale(1.1);
}
</style>
